import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
var _excluded = ["containerProps", "floatingLabelText", "required", "disabled", "error", "readOnly", "id", "loading"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from "react";
import { createShouldForwardProp, props } from "@styled-system/should-forward-prop";
import { border, color, compose, css, display, focusBorderColorProp, layout, placeholderTextProps, space, styled, system, themeGet, typography, useTheme } from "@catchoftheday/theme";
import { useUID } from "@catchoftheday/utilities";
import { Box } from "../Box";
import { Label } from "../Label";
import { LoadingSpinner } from "../LoadingSpinner";
import { jsx as ___EmotionJSX } from "@emotion/react";
var hoverColorTransform = system({
  hoverBorderColor: {
    property: "borderColor",
    scale: "colors"
  }
});
var activeTextColorTransform = system({
  activeTextColor: {
    property: "color",
    scale: "colors"
  }
});
var customStyles = compose(space, color, typography, border, display, layout);
var shouldForwardProp = createShouldForwardProp(_toConsumableArray(props.filter(function (prop) {
  return prop != "size";
})));

var InputLoading = function InputLoading(_ref) {
  var disabled = _ref.disabled;
  return ___EmotionJSX(LoadingSpinner, {
    position: "absolute",
    right: "10px",
    top: "50%",
    mt: "-10px",
    ringSize: "2px",
    ringBg: disabled ? "white" : "ui.backgroundColor",
    width: "20px",
    height: "20px"
  });
};

var BasicInput = styled("input", {
  shouldForwardProp: shouldForwardProp
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline: 0;\n  appearance: none;\n  transition: border-color ", ";\n\n  ", "\n\n  ::placeholder {\n    font-weight: ", ";\n    color: ", ";\n    ", "\n  }\n\n  ::-ms-input-placeholder {\n    font-weight: ", ";\n    color: ", ";\n    ", "\n  }\n\n  &:focus,\n  &:hover:not(:disabled) {\n    ", "\n  }\n\n  ", "\n\n  ", ";\n\n  :disabled {\n    cursor: not-allowed;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  ::-ms-clear {\n    display: none;\n  }\n\n  ", "\n\n  ", ";\n"])), themeGet("transitions.default"), customStyles, themeGet("fontWeights.normal"), themeGet("colors.typography.inactive"), placeholderTextProps, themeGet("fontWeights.normal"), themeGet("colors.typography.inactive"), placeholderTextProps, activeTextColorTransform, function (props) {
  return props.floatingLabelText && props.floatingLabelText.length > 0 && "\n    + label {\n      cursor: text;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      transition: all 0.2s ease;\n      transform: translateY(-50%);\n      pointer-events: none;\n    }\n\n    ::placeholder {\n      opacity: 0;\n    }\n\n    ".concat(props.readOnly ? ":placeholder-shown + label," : ":placeholder-shown + label {\n      top: 50%;\n      color: ".concat(themeGet("colors.typography.inactive"), ";\n    }"), "\n    :not(:placeholder-shown) + label,\n    :focus + label {\n      top: 0;\n      left: 0.5rem;\n      font-size: 0.75rem;\n      pointer-events: none;\n    }\n\n    :not(:placeholder-shown):not(:disabled) + label {\n      color: ").concat(props.error ? themeGet("colors.ui.error")(props) : "inherit", ";\n    }\n    ");
}, function (props) {
  return !props.error && !props.disabled && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      :focus {\n        ", "\n      }\n\n      :hover {\n        ", "\n      }\n\n      :placeholder-shown:hover + label {\n        color: ", ";\n      }\n\n      :focus + label {\n        color: ", ";\n      }\n    "])), focusBorderColorProp(props), hoverColorTransform(props), themeGet("colors.secondaryDark")(props), themeGet("colors.secondary")(props));
}, themeGet("colors.typography.inactive"), themeGet("colors.ui.backgroundColor"), function (props) {
  return props.underline && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      border: none;\n      border-bottom: ", ";\n      border-color: ", ";\n      border-radius: 0;\n      padding-bottom: 0.625rem;\n    "])), themeGet("borders.2")(props), themeGet("colors.ui.borderColor")(props));
}, function (props) {
  return props.error && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      border-color: ", ";\n      :not(:placeholder-shown) + label {\n        color: ", ";\n      }\n    "])), themeGet("colors.ui.error")(props), themeGet("colors.ui.error")(props));
});
export var Input = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _theme$colors, _theme$colors$typogra, _theme$colors2, _theme$colors2$ui, _theme$colors3, _theme$colors3$typogr, _theme$colors4, _theme$colors4$ui;

  var containerProps = _ref2.containerProps,
      _ref2$floatingLabelTe = _ref2.floatingLabelText,
      floatingLabelText = _ref2$floatingLabelTe === void 0 ? "" : _ref2$floatingLabelTe,
      required = _ref2.required,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      error = _ref2.error,
      readOnly = _ref2.readOnly,
      id = _ref2.id,
      loading = _ref2.loading,
      otherProps = _objectWithoutProperties(_ref2, _excluded);

  var theme = useTheme(); // eslint-disable-next-line react-hooks/rules-of-hooks

  var basicInputId = id || useUID();
  return floatingLabelText.length > 0 ? ___EmotionJSX(Box, _extends({
    position: "relative"
  }, containerProps), ___EmotionJSX(BasicInput, _extends({
    id: basicInputId,
    ref: ref,
    required: required,
    "aria-required": required,
    disabled: disabled,
    error: error,
    readOnly: readOnly,
    placeholder: floatingLabelText,
    floatingLabelText: floatingLabelText
  }, otherProps)), ___EmotionJSX(Label, {
    htmlFor: basicInputId,
    maxWidth: "66.6%",
    overflow: "hidden",
    width: "auto",
    position: "absolute",
    left: "1.25rem",
    px: "3px",
    mb: "0",
    required: required,
    color: disabled ? theme === null || theme === void 0 ? void 0 : (_theme$colors = theme.colors) === null || _theme$colors === void 0 ? void 0 : (_theme$colors$typogra = _theme$colors.typography) === null || _theme$colors$typogra === void 0 ? void 0 : _theme$colors$typogra.inactive : error ? (theme === null || theme === void 0 ? void 0 : (_theme$colors2 = theme.colors) === null || _theme$colors2 === void 0 ? void 0 : (_theme$colors2$ui = _theme$colors2["ui"]) === null || _theme$colors2$ui === void 0 ? void 0 : _theme$colors2$ui["error"]) || "red" : theme === null || theme === void 0 ? void 0 : (_theme$colors3 = theme.colors) === null || _theme$colors3 === void 0 ? void 0 : (_theme$colors3$typogr = _theme$colors3.typography) === null || _theme$colors3$typogr === void 0 ? void 0 : _theme$colors3$typogr.inactive,
    bg: !disabled ? "white" : theme === null || theme === void 0 ? void 0 : (_theme$colors4 = theme.colors) === null || _theme$colors4 === void 0 ? void 0 : (_theme$colors4$ui = _theme$colors4["ui"]) === null || _theme$colors4$ui === void 0 ? void 0 : _theme$colors4$ui["backgroundColor"]
  }, floatingLabelText), loading && ___EmotionJSX(InputLoading, {
    disabled: disabled
  })) : ___EmotionJSX(BasicInput, _extends({
    id: basicInputId,
    ref: ref,
    "aria-required": required,
    required: required,
    disabled: disabled,
    error: error,
    readOnly: readOnly
  }, otherProps));
});
Input.displayName = "Input";
Input.defaultProps = {
  p: 5,
  bg: "white",
  display: "block",
  width: "100%",
  color: "typography.text",
  fontSize: "base",
  lineHeight: "normal",
  border: 1,
  borderRadius: "default",
  borderColor: "ui.borderColor",
  textAlign: "left",
  hoverBorderColor: "secondaryDark",
  focusBorderColor: "secondary"
};
export default Input;